export default __webpack_public_path__ + "static/media/live-gfe-audio.9a97268c.svg";